import React from "react";
import { LightToolTip } from "./LightToolTip";

export default function ValidatorBatch(props) {
  const { type, text } = props;

  const wrapper = {
    position: "relative",
  }
  const messageIconContainer = {
    position: "absolute",
    transform: "translate(-16px, -4px)",
  }
  const messageIcon = {
    fontSize: "140%"
  }

  const getBatchColor = (type) => {
    if (type === "Error") return "red";
    if (type === "Warn") return "yellow";
    if (type === "Info") return "blue";
    return "black";
  }

  if (type && text) {
    return (
      <div style={wrapper}>
        <LightToolTip title={text}>
          <div style={messageIconContainer}>
            <i className={"dx-icon-info"} style={{...messageIcon, color: getBatchColor(type) }} />
          </div>
        </LightToolTip>
      </div>
    );
  }

  return <React.Fragment />;
}
